import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBW9rzlIVyY00ztFVgtT94qO54BDp3docc",
  authDomain: "cruit-app.firebaseapp.com",
  projectId: "cruit-app",
  storageBucket: "cruit-app.firebasestorage.app",
  messagingSenderId: "628001111717",
  appId: "1:628001111717:web:ba35ef3d99d17b9932574c",
  measurementId: "G-RDQF5ND1HM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app; 